<template>
  <v-container>
    <FlightForm/>
    <DisclaimerRow/>
  </v-container>
</template>

<script>
import FlightForm from "@/components/FlightForm/FlightForm.vue";
import DisclaimerRow from "@/components/General/DisclaimerRow.vue";

export default {
    name: 'BaseView',
    components: {DisclaimerRow, FlightForm}

}
</script>

<style scoped>

</style>
